<template>
  <v-container fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="settings.data"
        :options.sync="options"
        item-key="country_code"
        :footer-props="footerProps"
        :loading-text="$t('findInStore.settings.table.loading')"
        :no-data-text="$t('findInStore.settings.table.empty')"
        mobile-breakpoint="481"
        :loading="settings.loading"
        dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn v-if="isAdmin" @click="createSetting" color="primary" outlined>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.updated_at="{ item }">
          {{ formatDate(item.updated_at) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 481 ? '' : 'pr-0']"
            text
            color="primary"
            @click="executeAction(item.country_code)"
          >
            {{ $t('findInStore.settings.table.details') }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <simple-choice-dialog
      v-model="formSettingsDialog"
      :title="$t('settings.selectCountry')"
      :introductionSentence="$t('settings.selectACountryBelow')"
      :choices="countriesWithNoSettings"
      :choicesListLabel="$t('settings.country')"
      @confirm="addAction"
    ></simple-choice-dialog>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { EventBus } from '../../event-bus'
  import SimpleChoiceDialog from '../../components/dialogs/SimpleChoiceDialog.vue'
  import { formatCountryLabel } from '@/helpers/countries'

  export default {
    name: 'FindInStoreSettingsTable',
    components: { SimpleChoiceDialog },
    data() {
      return {
        settings: {
          data: [],
          loading: false,
          total: 0,
        },
        footerProps: {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('findInStore.settings.table.perPage'),
        },
        options: {
          itemsPerPage: 15,
        },
        formSettingsDialog: false,
        countries: {
          withSettings: [],
        },
      }
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    computed: {
      ...mapState(['isAdmin']),
      allCountries() {
        return this.$loadCountries(this.$i18n.locale)
      },
      headers() {
        return [
          {
            text: this.$t('return.settings.countryCode'),
            value: 'country_code',
            filterType: 'text',
            sortable: false,
          },
          {
            text: this.$t('settings.lastUpdate'),
            value: 'updated_at',
            filterType: 'text',
            sortable: true,
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ]
      },
      countriesWithNoSettings() {
        const result = []

        if (!Array.isArray(this.countries.withSettings) || !this.countries.withSettings.includes('default')) {
          result.push({
            display: this.$t('findInStore.settings.defaultConfiguration'),
            value: 'default',
          })
        }

        return result.concat(
          this.allCountries
            .filter(
              (country) =>
                !Array.isArray(this.countries.withSettings) ||
                this.countries.withSettings.length === 0 ||
                !this.countries.withSettings.includes(country.iso_2_code)
            )
            .map((country) => {
              return {
                display: formatCountryLabel(country, 'iso_2_code'),
                value: country.iso_2_code,
              }
            })
        )
      },
    },
    methods: {
      async reloadList() {
        await this.$auth.isAuthenticated()
        this.list()
      },
      list() {
        if (this.settings.loading) {
          return
        }
        this.settings.loading = true
        const { page, itemsPerPage, sortDesc, sortBy } = this.options
        const myInit = {
          headers: {
            Authorization: `Bearer ${this.$auth.accessToken}`,
          },
          queryStringParameters: {
            sortBy: sortBy.length === 0 ? 'country_code' : sortBy,
            sortDesc: sortDesc.length === 0 ? true : sortDesc,
            page,
            itemsPerPage,
          },
        }
        this.$Amplify.API.get('findInStore', '/v1/int/settings', myInit)
          .then((res) => {
            this.settings.data = res?.settings ?? []
            if (Array.isArray(this.settings.data) && this.settings.data.length > 0) {
              this.settings.data.forEach((setting) => {
                const code = setting?.country_code?.trim()
                if (![null, undefined, ''].includes(code) && !this.countries.withSettings.includes(code)) {
                  this.countries.withSettings.push(code)
                }
              })
            }
            this.settings.total = res?.nbSettings ?? 0
            this.settings.loading = false
          })
          .catch((e) => {
            console.log(e)
            this.settings.loading = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('findInStore.settings.table.error'),
              color: 'error',
            })
          })
      },
      addAction: function (countryCode) {
        this.$router.push({
          name: 'FindInStoreSettingsAdd',
          params: {
            id: countryCode,
          },
        })
      },
      executeAction: function (countryCode) {
        this.$router.push({ path: `/find-in-store-settings/${countryCode}` })
      },
      createSetting() {
        this.settingToUpdate = null
        this.formSettingsDialog = true
      },
      formatDate(date) {
        return date ? moment(date).format('DD/MM/YY HH:mm') : ''
      },
    },
  }
</script>
